// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loding_loader__1yc5H"};